export default {
    computed: {
        pageTitle() {
            return ''
        },
        pageDescription() {
            return ''
        },
        pageImage() {
            return ''
        },
    },

    methods: {
        composeDocumentTitle() {
            document.title = this.pageTitle ? `${this.pageTitle} — ${this.$t('common.app_name')}` : this.$t('common.app_name')
            document.head.querySelector('meta[property="og:title"]').content = this.pageTitle
                ? this.pageTitle
                : this.$t('pages.auth.head.title')
        },
        composeDocumentDescription() {
            document.head.querySelector('meta[property="og:description"]').content = this.pageDescription
                ? this.pageDescription
                : this.$t('pages.auth.head.description')
        },
        composeDocumentImage() {
            document.head.querySelector('meta[property="og:image"]').content = this.pageImage
                ? this.pageImage
                : this.$t('pages.auth.head.image')
        },
    },

    mounted() {
        this.composeDocumentTitle()
        this.composeDocumentDescription()
        this.composeDocumentImage()
    },

    watch: {
        pageTitle() {
            this.composeDocumentTitle()
        },
        pageDescription() {
            this.composeDocumentDescription()
        },
        pageImage() {
            this.composeDocumentImage()
        },
    },
}
